"use strict";

define('uikit/collections/list',['underscore', 'marionette', '../channel', '../mixins/component.mixin', '../templates', '../extra/size', '../collections/container'], function (_, Mn, channel, ComponentMixin, Templates, Size, Container) {
  var ListItem = Mn.ItemView.extend(ComponentMixin).extend({
    className: 'item',
    template: Templates.UIKit['list.item'],
    options: {
      completed: false,
      link: false,
      header: '',
      text: '',
      icon: '',
      image: '',
      imageAlt: '',
      imageClass: '',
      useRightContainer: false,
      _index: -1
    },
    update: {
      completed: false
    },
    ui: {
      'content': '> .content'
    },
    internalViews: {
      rightContainer: Container.extend({
        className: 'right floated'
      })
    },
    serializeData: function serializeData() {
      var data = ComponentMixin.serializeData.apply(this, arguments),
        linkFormatter = this.getOption('linkFormatter');
      if (_.isFunction(linkFormatter)) {
        data.linkHref = linkFormatter.call(this, this.model);
        data.link = true;
      }
      return data;
    },
    updateAttributes: function updateAttributes() {
      this.addClass('completed', this.getBoolOption('completed'));
    }
  });
  var List = Mn.CollectionView.extend(ComponentMixin).extend({
    className: 'ui list',
    childView: ListItem,
    childViewEventPrefix: 'item',
    options: {
      bulleted: false,
      celled: false,
      divided: false,
      horizontal: false,
      inverted: false,
      ordered: false,
      relaxed: false,
      selection: false,
      padded: false,
      size: ''
    },
    sizeOptionValues: _.values(Size),
    update: {
      bulleted: false,
      celled: false,
      divided: false,
      horizontal: false,
      inverted: false,
      ordered: false,
      relaxed: false,
      selection: false,
      padded: false,
      size: false
    },
    updateAttributes: function updateAttributes() {
      this.addClass('bulleted', this.getBoolOption('bulleted'));
      this.addClass('celled', this.getBoolOption('celled'));
      this.addClass('divided', this.getBoolOption('divided'));
      this.addClass('horizontal', this.getBoolOption('horizontal'));
      this.addClass('inverted', this.getBoolOption('inverted'));
      this.addClass('ordered', this.getBoolOption('ordered'));
      this.addClass('selection', this.getBoolOption('selection'));
      this.addClass('padded', this.getBoolOption('padded'));
      this.addClass(this.getOption('size'), this.getBoolOption('size'));
      var relaxed = _.isString(this.getOption('relaxed')) ? this.getOption('relaxed') + ' relaxed' : 'relaxed';
      this.addClass(relaxed, this.getBoolOption('relaxed'));
    }
  });
  channel.reply('list', function () {
    return List;
  });
  List.Item = ListItem;
  return List;
});

